import { CSSProperties, useState } from 'react';
import { FieldError } from 'react-hook-form';

import { TextInput } from 'coreOld/components';
import { Icon } from 'coreOld/elements';
import { AlignText, Size } from 'coreOld/enums';

interface IProps {
  htmlFor?: string;
  name?: string;
  style?: CSSProperties;
  size?: Size;
  type?: string;
  icon?: JSX.Element;
  endIcon?: JSX.Element;
  placeholder?: string;
  disabled?: boolean;
  editable?: boolean;
  fontInherit?: boolean;
  value?: string;
  defaultValue?: string;
  hasBorder?: boolean;
  textAlign?: AlignText;
  control?;
  onChange?;
  onChangeFilter?;
  onBlur?;
  onKeyDown?;
  onClick?;
  error?: FieldError | string;
  autoFocus?: boolean;
}

const PasswordInputView = ({ ...inputProps }: IProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextInput
      {...inputProps}
      type={showPassword ? 'text' : 'password'}
      endIcon={
        <Icon
          onClick={() => setShowPassword(!showPassword)}
          name={showPassword ? Icon.EYE : Icon.EYE_SLASH}
        />
      }
    />
  );
};

export default PasswordInputView;
